export default {"src":"/_next/static/media/revenue.056f8c7a.svg","height":50,"width":50};